module.exports = __webpack_public_path__ + "static/1_1_defineai_GA-b7d1f0156c1fdde1a76b83c469e4efd7.svg";